import { render } from "./Parametrizacion.vue?vue&type=template&id=0227d305"
import script from "./Parametrizacion.vue?vue&type=script&lang=js"
export * from "./Parametrizacion.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__